export const randomHex = (length: number) =>
{
    const maxLength = 8;
    const min = Math.pow(16, Math.min(length, maxLength) - 1);
    const max = Math.pow(16, Math.min(length, maxLength)) - 1;
    const n   = Math.floor( Math.random() * (max - min + 1) ) + min;
    let r   = n.toString(16);
    while ( r.length < length ) 
    {
       r = r + randomHex( length - maxLength );
    }
    return r;
  };


// WEBPACK FOOTER //
// ./src/util/hexString.ts